import SpindlLogo, { SpindlLogoProps } from './SpindlLogo';

export type { SpindlLogoProps };
export default SpindlLogo;
